"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanVariable = void 0;
const APlanType_1 = require("./APlanType");
const planVariableTypes_1 = __importDefault(require("./planVariableTypes"));
class PlanVariable extends APlanType_1.APlanType {
    variableName;
    // metadata stuff
    constructor(required, options) {
        super(required, options);
        this.variableName = required.variableName;
        this.type = required.type;
        if (options?.feId) {
            this.feId = options.feId;
        }
        if (options?.displayName) {
            this.displayName = options.displayName;
        }
    }
    index() {
        return this.getId();
    }
    getDisplayName() {
        return this.displayName || this.variableName;
    }
    getId() {
        if (this.feId) {
            return this.feId;
        }
        if (this.id == 0) {
            return "";
        }
        return this.id.toString();
    }
    getOriginalId() {
        return this.id;
    }
    getVariableName() {
        return this.variableName;
    }
    getBranchId() {
        if (this.branchId == 0) {
            return "";
        }
        return this.branchId.toString();
    }
    getOriginalBranchId() {
        return this.branchId;
    }
    isStrValue() {
        return this.type === planVariableTypes_1.default.STR;
    }
    isNumValue() {
        return this.type === planVariableTypes_1.default.NUM;
    }
}
exports.PlanVariable = PlanVariable;
